import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/Auth/authSlice";
import villageReducer from "../features/Village/village.slice";
import districtReducer from "../features/District/district.slice";
import talukaReducer from "../features/Taluka/taluka.slice";
import businessReducer from "../features/Business/business.slice";
import jobReducer from "../features/Job/job.slice";
import studyReducer from "../features/Study/study.slice";
import countryReducer from "../features/Country/country.slice";
import stateReducer from "../features/State/state.slice";
import helpLineReducer from "../features/HelpLineNumber/helpLineNumber.slice";
import donatDetailsReducer from "../features/Donate/donate.slice";
import calendarReducer from "../features/Calendar/calendar.slice";
import relationReducer from "../features/Relation/relation.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    village: villageReducer,
    district: districtReducer,
    taluka: talukaReducer,
    business: businessReducer,
    job: jobReducer,
    study: studyReducer,
    country: countryReducer,
    state: stateReducer,
    helpLineNumber: helpLineReducer,
    donatDetails: donatDetailsReducer,
    calendar: calendarReducer,
    relation: relationReducer,
  },
});
